import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PermissionService } from './modules/buildings-shared/services/permission.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, FooterComponent, RouterLink],
    templateUrl: './app.html',
    styleUrl: './app.scss',
    providers: [PermissionService]
})
export class App implements OnInit {

    @ViewChild('openModalCookiePolicyButton', { static: true })
    openModalCookiePolicyButton!: ElementRef<HTMLButtonElement>;

    protected readonly title = signal('buildings-frontend');

    popupType = signal<string>('');
    popupMessage = signal<string>('');
    
    permissionService: PermissionService;

    constructor(permissionService: PermissionService, private readonly router: Router) {
        this.permissionService = permissionService;
        this.permissionService.popupActivation.subscribe( ({type, message}: {type: string, message: string}) => {
            this.popupType.set(type);
            this.popupMessage.set(message);
        });
        console.log("Buildings-frontend application is running. Stage: " + environment.env);
    }

    ngOnInit(): void {
        if(this.permissionService.checkCookies() === false) {
            this.openModalCookiePolicyButton.nativeElement.click();
        }
    }

    acceptCookies(): void {
        this.permissionService.acceptCookies();
        this.router.navigate(['/']);
    }

    cookesPolicy(): void {
        this.router.navigate(['/cookiesPolicy']);
    }
}